module.exports = __webpack_public_path__ + "img/Alexion-Kongre-Banner+2.2b8b4604.jpeg";